// Home.js
import React, { useState, useEffect } from 'react';
import './Home.css';
import { app, database } from '../FirebaseConfig';
import { onSnapshot, collection, doc, updateDoc, setDoc, increment } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';


const Home = () => {
    const auth = getAuth(app);
    const [localAuthState, setLocalAuthState] = useState(false);
    const [localUser, setLocalUser] = useState(null);
    const [clickCount, setClickCount] = useState(0);
    const DebounceDueTime = 200
    var debounceTimeout;
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (debounceTimeout)
                clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() =>
            {
                debounceTimeout = null;
                handleAuthStateChanged(user);
            }, DebounceDueTime);
        })
      }, [auth])

    const handleAuthStateChanged = (user) => {
        if(user){
            console.log("Logged In")
            subscribeToClickCount(user.email);
            setLocalUser(user);
            setLocalAuthState(true);
        }
        else {
            console.log('Not Logged In')
            setClickCount(0)
            setLocalAuthState(false);
            setLocalUser(null);
        }
    }
    const subscribeToClickCount = (userEmail) => {
        const userDoc = doc(database, 'clicks', userEmail);
    
        const unsubscribeDoc = onSnapshot(userDoc, (doc) => {
          if (doc.exists()) {
            const data = doc.data();
            setClickCount(data.clickCount || 0);
          } else {
            // If the document doesn't exist, initialize it with a click count of 0
            setDoc(userDoc, { clickCount: 0 });
          }
          return () => unsubscribeDoc();
        });
    }
        

        const handleButtonClick = async () => {
            if (localUser) {
              const userDoc = doc(database, 'clicks', localUser.email);
              await updateDoc(userDoc, {
                clickCount: increment(1)
              });
            }
          };
        
  return (
    <div class="container">
        <h1 class="main-heading">Home Page</h1>
        {localAuthState ? (
            <div class="auth-content">
                <h2 class="welcome-message">Welcome back, {localUser.email}</h2>
                <button class="click-button" onClick={handleButtonClick}>Click Me</button>
                <h3 class="click-count">Button Clicked {clickCount} times.</h3>
            </div>
        ) : (
        <h2 class="login-prompt"><a class="login-link" href='/Login'>Log in</a> to see content.</h2>
        )}
  </div>
  );
};

export default Home;
